import { User } from 'modules/roles-manager/domain/interfaces/user';
import roleUsers, { UpdateUserPayload } from 'modules/roles-manager/domain/resources/role-users';
import { useMutation, useQueryClient } from 'react-query';

export function useUpdateUser(tournamentId?: number) {
  const queryClient = useQueryClient();

  return useMutation<User, unknown, UpdateUserPayload>(
    (payload) => {
      if (!tournamentId) throw new Error('No tournamentId');
      return roleUsers.updateUser(tournamentId, payload);
    },
    {
      onSuccess: (updated) => {
        // Patch page-based cache
        const keys = queryClient.getQueryCache().findAll('roleUsers');
        keys.forEach((query) => {
          const key = query.queryKey as any[];
          if (!Array.isArray(key)) return;
          if (key[0] !== 'roleUsers') return;
          if (key[1] !== tournamentId) return;
          queryClient.setQueryData<User[]>(key, (old) => {
            if (!old) return old as any;
            const idx = old.findIndex((u) => u.id === updated.id);
            if (idx === -1) return old;
            const copy = old.slice();
            copy[idx] = updated;
            return copy;
          });
        });

        // Optional individual cache by id
        queryClient.setQueryData(['roleUser', updated.id], updated);
      },
    },
  );
}

export default useUpdateUser;
